export enum TabSelection {
  Overview = 0,
  Detail = 1,
}
